<template>
    <!-- IMAGE BANNER -->
    <section class="imageBanner">
        <img src="@/assets/donate/bentechBanner.png" class="img-fluid" alt="happy children">
    </section>
    
    <!-- DONATION SECTION -->
    <section class="donateSection">
        <div class="container text-center text-white donateContainer" style="background-color: #2F437A; border-radius: 20px;">
            <div class="row">

                <!-- FIRST COLUMN -->
                <div class="col-sm-9">
                    <div class="row">
                        <div class="col" id="videoContent">
                            <div class="video">
                                <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/KbSAcU_eK2o" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> -->
                                <iframe src="https://www.youtube.com/embed/KbSAcU_eK2o" width="902" height="315" title="A YouTube video" frameborder="0" allowfullscreen></iframe>
                            </div>
                        <div class="videoDescription">
                            <p><span style="color: #fec93c">The BenTech Project is a significant initiative by the Tech for 
                                Filipino Youth Organization that focuses on addressing digital poverty in the Philippines. The project 
                                aims to raise awareness of the issue and to collect funds to provide educational opportunities for underprivileged 
                                Filipino youth who lack access to technology. The project encourages anyone and everyone who is interested in making a 
                                difference in the lives of these kids to participate and to donate as little as 20 pesos (PhP). The project recognizes that 
                                education is a critical component of breaking the cycle of poverty and empowering individuals to reach their full potential.
                                By supporting this project, individuals can make a significant difference in the lives of these children and contribute to building a 
                                more equitable and just society.<br></span></p>
                        </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="container" id="bpi">
                                <img src="@/assets/donate/bpi.png" class="img-fluid" alt="BPI Payment Details">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SECOND COLUMN -->
                <div class="col-sm-3">
                    <div class="row">
                    <div class="col">
                        <div class="container" id="gcash">
                            <img src="@/assets/donate/gcash3.png" class="img-fluid" alt="GCash QR Code">
                        </div>
                            <div class="gcashDescription">
                                <p><span>Be a BENTECH hero with GCash! GCash is a mobile wallet and online payment platform based in the Philippines. You may send your donations by scanning the QR.</span></p>
                            </div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col">
                        <div class="container">
                        
                        <div class="container" id="gofundme">
                        <!-- GOFUNDME -->
                            <img src="@/assets/donate/gofundmecircle.png" class="img-fluid" alt="GoFundme Logo">
                        </div>
                        <div class="goFundMeDescription">
                        <p><span>Be a BENTECH hero with GoFundMe! GoFundMe enables individuals and organizations to create a campaign and share it with their network to request donations. Note that a small fee for processing your donation may be charged to your account.</span></p>
                        </div>
                        <span>
                            <a href="https://www.gofundme.com/f/online-class-tablet-for-unfortunate-filipino-youth?utm_source=customer&utm_campaign=p_cp+share-sheet&utm_medium=copy_link_all">
                            <button type="button" class="gofundmeButton goPalButton" style="--bs-btn-padding-x: 0.9rem">Donate through GoFundMe</button></a>
                        </span>
                        </div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col">
                        <div class="container" id="paypal">
                            <img src="@/assets/donate/paypalcircle.png" class="img-fluid" alt="PayPal Logo">
                        </div>
                        <div class="payPalDescription">
                            <p><span>Be a BENTECH hero with PayPal! PayPal is a digital payment system that allows individuals and businesses to send and receive payments online.</span></p>
                            </div>

                        <span>
                            <a href="https://www.paypal.com/paypalme/arulics">
                            <button type="button" class="payPalButton goPalButton" style="--bs-btn-padding-x: 0.9rem">Donate through PayPal</button>
                        </a>
                        </span>
                    </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<style scoped>
#collapsedNavBarLinks > li {
 color: white;
}
</style>

<style scoped src="@/assets/css/donateStyle.css"></style>